<template>
    <div class="imitate-box">
        <div class="imitate-top-box">
            <Breadcrumb></Breadcrumb>
            <div class="imitate-content-box">
                <h2>模拟填报</h2>
                <h4>通过单次模考成绩，智能分析能报考的学校和录取概率，并模拟填报志愿，<br>做到有备无患</h4>
            </div>
        </div>
        <div class="imitate-frame-box">
            <div>
                <div class="imitate-frame-title"><span></span>新增模拟填报</div>
                <el-form :inline="true" :model="form" ref="form" class="imitate-form-inline" :rules="rules" label-position="right" label-width="115px">
                    <el-form-item label="科目组合：" prop="subject_name">
                       <!--  <el-button v-for="(item,index) in subject_list" :class="index == active_index ? 'active-batch':''" :key="index" @click="changeSubject(index)">{{ item }}</el-button> -->
                       <el-input disabled v-model="form.subject_name">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="考试名称：" prop="exam_name">
                        <el-select v-model="form.exam_name" placeholder="请输入考试名称" filterable allow-create>
                            <el-option v-for="(item, index) in exam_name" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="考试分数：" prop="exam_score">
                        <el-input v-model="form.exam_score" placeholder="请输入考试分数">
                            <template slot="append">分</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="分数调整：" prop="input_score" class="imitate-form-item">
                        <el-button v-for="(item,index) in type_list" :class="index == active_index1 ? 'active-batch':''" :key="index" class="imitate-btn-diff" @click="changeScore(index)">{{ item }}</el-button>
                        <el-input v-model="form.input_score" placeholder="请输入调整分数" class="imitate-input-diff">
                            <template slot="append">分</template>
                        </el-input>
                    </el-form-item>
                    <el-button type="primary" @click="onSubmit" class="imitate-btn-submit">开始模拟填报</el-button>
                </el-form>
            </div>
            <div>
                <div class="imitate-record-box">
                    <div class="imitate-record-title">模拟填报记录</div>
                    <div v-if="show_empty == '2'">
                        <el-row :gutter="24">
                            <el-col :span="12">
                                <div class="imitate-echart-box">
                                    <h4>分数趋势</h4>
                                    <div ref="imitateCanvas1" class="imitate-canvas"></div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="imitate-echart-box">
                                    <h4>位次趋势</h4>
                                    <div ref="imitateCanvas2" class="imitate-canvas"></div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="imitate-record-item" v-for="(item, index) in plan_list" :key="index">
                            <el-col :span="16">
                                <div class="imitate-zyb-infor">
                                	{{ item.plan_title }} 
                                	<span class="imitate-lk-infor">{{ item.plan_desc.split('/')[0] }}</span>
                                	<span class="imitate-zyb-span"></span>
                                	<span>{{ item.plan_desc.split('/')[1] }}</span>
                                </div>
                                <div class="imitate-zyb-date">录取总概率：
                                	<span>{{ item.avg_percent ? item.avg_percent : '-' }}%</span>
                                	创建时间：{{ item.create_time }}
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <el-button @click="linkDetailHandler(item.id,item.plan_title)">查看</el-button>
                                <el-button @click="updateHandler(item)">编辑</el-button>
                                <el-button @click="deletePlanHandler(item.id,index)">删除</el-button>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="show_empty == '1'" class="no-data-box">
                        <img src="../../assets/images/null.png">
                        <p>暂无填报记录</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts'
import { mapState } from "vuex"
import { getScoreLine, getMyVirtualPlanList, deleteMyPlan,getVirtualHistoryData } from "@/api/zhiyuan"
export default {

    name: 'imitateAspiration',

    data() {
        const validateScore = (rule, value, callback) => {
            if (value.length === 0) {
            callback(new Error("请输入分数"));
            } else {
                if ((/(^[1-9]\d*$)/.test(value)) && value > 0) {
                    callback();
                } else {
                    callback(new Error("请输入正确的分数"));
                }
            }
        };
        const validateAdjustScore = (rule, value, callback) => {
            if (value.length === 0) {
                callback();
            } else {
                if ((/(^[1-9]\d*$)/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的分数"));
                }
            }
        };  
        return {
            form: {
                local_type_id: '',
                local_batch_type: '10',
                subject_name: localStorage.getItem('subject_name'),
                exam_name: '',
                exam_score: '',
                adjust_score: '',
                score: '',
                input_score: ''
            },
            exam_name: ['第一次模拟考试', '第二次模拟考试', '第三次模拟考试'],
            subject_list: JSON.parse(sessionStorage.getItem('subjectObj')),
            active_index: 1,
            active_index1: 0,
            type_list: ['加', '减'],
            rules: {
                local_type_id: [{
                    required: true, trigger: 'blur'
                }],
                subject_name: [{
                    required: true, trigger: 'blur'
                }],
            	exam_name: [{
            		required: true, message: '请输入考试名称', trigger: 'blur'
            	}],
                exam_score: [{
            		required: true, validator: validateScore, trigger: 'blur'
            	}],
                input_score: [{
                    required: false, validator: validateAdjustScore, trigger: 'blur'
                }]
            },
            plan_list: [],
            x_score_list: [],
            y_score_list: [],
            x_section_line_list: [],
            y_section_line_list: [],
            show_empty: '0',
            has_code: 0,
            show_flag: false
        }
    },
    computed: {
        ...mapState({
            token: state => state.user.token,
            function_code: state => state.user.function_code,
            localTypeId: state => state.user.localTypeId
        }),
    },
    watch: {
        token(newVal) {
            if (newVal != '') {
                this.getMyVirtualPlanList();
            }
        },
        function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00010'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }
    },
    mounted() {
        const tmp = this.function_code.filter(item => { return item.function_code === 'F00010'})
        if(tmp.length > 0) {
            this.has_code = tmp[0].has_code
        }
        this.form.local_type_id = this.localTypeId
        this.active_index = Object.keys(this.subject_list)[0]
        this.getMyVirtualPlanList()
    },
    methods: {
        getMyVirtualPlanList() {
            const x_score_list = []
            const y_score_list = []
            const x_section_line_list = []
            const y_section_line_list = []
            getMyVirtualPlanList().then(res => {
                const data = res.data
                this.show_flag = true
                if(data.list.length == 0) {
                    this.show_empty = '1'
                    return
                } else {
                    this.show_empty = '2'
                    this.plan_list = data.list
                    data.score_list.map(item => {
                        x_score_list.push(item.plan_title)
                        y_score_list.push(item.score)
                    })
                    data.section_line_list.map(item => {
                        x_section_line_list.push(item.plan_title)
                        y_section_line_list.push(item.section_line)
                    })
                    this.x_score_list = x_score_list
                    this.y_score_list = y_score_list
                    this.x_section_line_list = x_section_line_list
                    this.y_section_line_list = y_section_line_list
                    this.$nextTick(() => {
                        this.myChart1()
                        this.myChart2()
                    });
                }
            })
        },
        myChart1() {
            const myChart = echarts.init(this.$refs.imitateCanvas1);
            const option = {
                tooltip: {
                   trigger: 'axis',
                   formatter: function(params) {
                     let firstParams = params[0]
                     return firstParams.name + '<br>分数：' +firstParams.data
                   }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#c4c7cc",
                            width: 1
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        show: true,
                        color: "#999390",
                        fontSize: 12,
                        interval: 0,
                        padding: [5, 0, 0, 0],
                        formatter: function(params) {
                            var newParamsName = "";
                            var paramsNameNumber = params.length;
                            var provideNumber = 7;  
                            var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                            if (paramsNameNumber > provideNumber) {
                                for (var p = 0; p < rowNumber; p++) {
                                    var tempStr = "";
                                    var start = p * provideNumber;
                                    var end = start + provideNumber;
                                    if (p == rowNumber - 1) {
                                        tempStr = params.substring(start, paramsNameNumber);
                                    } else {
                                        tempStr = params.substring(start, end) + "\n";
                                    }
                                    newParamsName += tempStr;
                                }

                            } else {
                                newParamsName = params;
                            }
                            return newParamsName
                        }
                    },
                    data: this.x_score_list,
                },
                grid: {
                    left: '10%',
                    right: '10%',
                    top: '36',
                    width: '80%',
                    height: '120',
                    containLabel: true
                },
                yAxis: {
                    type: 'value',
                    // max : 15000,
                    // min : 0,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: [{
                    data: this.y_score_list,
                    type: 'line',
                    label: {
                        show: true,
                        color: "#3474ff",
                        fontSize: 12
                    },
                    itemStyle: {
                        color: "#3474ff"
                    },
                    lineStyle: {
                        color: "#3474ff",
                        width: 1
                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                [
                                    { offset: 0.8, color: 'rgba(52,116,255,0.14)' },
                                    { offset: 1, color: 'rgba(52,116,255,0.00)' }
                                ]
                            )
                        },
                    }
                }],
            };
            myChart.setOption(option);
        },
        myChart2() {
            const myChart = echarts.init(this.$refs.imitateCanvas2);
            const option = {
                tooltip: {
                   trigger: 'axis',
                   formatter: function(params) {
                     let firstParams = params[0]
                     return firstParams.name + '<br>位次：' +firstParams.data
                   }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#c4c7cc",
                            width: 1
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        show: true,
                        color: "#999390",
                        fontSize: 12,
                        interval: 0,
                        padding: [5, 0, 0, 0],
                        formatter: function(params) {
                           var newParamsName = "";
                            var paramsNameNumber = params.length;
                            var provideNumber = 7;  
                            var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                            if (paramsNameNumber > provideNumber) {
                                for (var p = 0; p < rowNumber; p++) {
                                    var tempStr = "";
                                    var start = p * provideNumber;
                                    var end = start + provideNumber;
                                    if (p == rowNumber - 1) {
                                        tempStr = params.substring(start, paramsNameNumber);
                                    } else {
                                        tempStr = params.substring(start, end) + "\n";
                                    }
                                    newParamsName += tempStr;
                                }

                            } else {
                                newParamsName = params;
                            }
                            return newParamsName
                        }
                    },
                    data: this.x_section_line_list
                },
                grid: {
                    left: '10%',
                    right: '10%',
                    top: '36',
                    width: '80%',
                    height: '120',
                    containLabel: true
                },
                yAxis: {
                    type: 'value',
                    // max : 15000,
                    min: 0,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: [{
                    data: this.y_section_line_list,
                    type: 'line',
                    areaStyle: {},
                    label: {
                        show: true,
                        color: "#3474ff",
                        fontSize: 12
                    },
                    itemStyle: {
                        color: "#3474ff"
                    },
                    lineStyle: {
                        color: "#3474ff",
                        width: 1
                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                [
                                    { offset: 0.8, color: 'rgba(52,116,255,0.14)' },
                                    { offset: 1, color: 'rgba(52,116,255,0.00)' }
                                ]
                            )
                        },
                    }
                }],
            };
            myChart.setOption(option);
        },
        onSubmit() {
            if(this.has_code == 0) {
                this.$message({
                    message: '您的账户暂未开通此功能',
                    type: 'warning'
                })
                return
            }
            this.$refs.form.validate((valid) => {
                if(valid) {
                    if(this.form.input_score) {
                        if(this.active_index1 == 1) {
                            this.form.adjust_score = -this.form.input_score
                        } else {
                            this.form.adjust_score = this.form.input_score
                        }
                        this.form.score = Number(this.form.exam_score) + Number(this.form.adjust_score)
                    } else {
                        this.form.score = Number(this.form.exam_score)
                    }
                    const local_type_id = this.active_index
                    getScoreLine(this.active_index, localStorage.getItem("area")).then(res => {
                        if (res.status != 200 || !res) {
                            return
                        }
                        const data = res.data.pro_score
                        const max = this.form.score
                        let keyArr = Object.keys(data).sort(function(a, b) {        
                            return data[b] - data[a]
                        })
                        for (let i = 0; i < keyArr.length; i++) {
                            if(keyArr[i] != '6' && keyArr[i] != '11') {
                                if(data[keyArr[i]] <= max) {
                                    this.form.local_batch_type = keyArr[i]
                                    break
                                }
                            }
                        }
                        const params = this.form
                        params.flag = 'add'
                        params.id = ''
                        params.plan_title = ''
                        params.subject = this.subject_list[this.form.local_type_id].name
                        getVirtualHistoryData(params).then(res => {
                            if(res.status == 200) {
                                localStorage.setItem("imitate_data", JSON.stringify(params))
                                 this.$router.push({
                                    path: '/zhiyuan'
                                })  
                            } else {
                                this.$message({
                                    message: '暂无相关数据',
                                    type: 'error'
                                });
                            }
                        })
                    })
                }
            })
           
        },
        changeSubject(index) {
        	this.active_index = index
            this.form.local_type_id = index
        },
        changeScore(index) {
        	this.active_index1 = index
        },
        linkDetailHandler(id,title) {
            this.showPerson = false;
            this.$router.push({
                path: '/detail',
                query:{
                    id: id,
                    title: title
                }
            })
        },
         deletePlanHandler(id,index) {
            deleteMyPlan(id).then(res => {
                if(res.message == 'success') {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getMyVirtualPlanList();
                } else {
                    this.$message({
                        message: '删除失败',
                        type: 'error'
                    });
                }
            })
        },
        updateHandler(data) {
            const plan_base_info = data.plan_base_info
            const tmp = {
                local_type_id: plan_base_info.local_type_id,
                local_batch_type: plan_base_info.local_batch_type,
                exam_name: plan_base_info.exam_name,
                exam_score: plan_base_info.exam_score,
                adjust_score: plan_base_info.score_adjust,
                score: plan_base_info.exam_score + plan_base_info.score_adjust,
                subject: plan_base_info.subject_type,
                plan_title: data.plan_title
            }
            const params = Object.assign(data,tmp)
            params.flag = 'edit'
            localStorage.setItem("imitate_data", JSON.stringify(params))
            this.$router.push({
                path: '/zhiyuan'
            }) 
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.imitate-box {
    .imitate-top-box {
        background: url('../../assets/images/imitate_bg.png') no-repeat;
        height: 330px;
        background-position: center;
        background-size: cover;

        .imitate-content-box {
            @include gwidth;

            h2 {
                font-size: 40px;
                font-weight: 700;
                color: #ffffff;
                line-height: 56px;
                letter-spacing: 2px;
                margin-bottom: 0;
            }

            h4 {
                font-size: 18px;
                font-weight: 400;
                text-align: left;
                color: rgba(255,255,255,0.7);
                line-height: 28px;
                margin-top: 16px;
            }
        }
    }

    .imitate-frame-box {
        background: #ffffff;
        border-radius: 10px;
        backdrop-filter: blur(7px);
        @include gwidth;
        margin-top: -56px;
        padding: 24px;
        box-sizing: border-box;

        .imitate-frame-title {
            font-size: 20px;
            font-weight: 600;
            color: #2c2e33;
            line-height: 28px;
            margin-bottom: 12px;

            span {
                display: inline-block;
                width: 3px;
                height: 20px;
                background: #ff6524;
                position: relative;
                top: 2px;
                margin-right: 10px;
            }
        }

        ::v-deep .imitate-form-inline {
            background: #eef5ff;
            border: 1px solid #e1e4eb;
            border-radius: 10px;
            padding: 24px 48px 32px 48px;

            .el-form-item {
                width: 50%;
                margin-right: 0;
            }
            .imitate-form-item {
                .el-form-item__error {
                    margin-left: 180px;
                }
            }

            .el-form-item__label {
                font-size: 16px;
                color: #2c2e33;
                line-height: 52px;
                padding: 0;
            }

            .el-input {
                background: #ffffff;
                border: 1px solid #e1e4eb !important;
                border-radius: 8px;
                width: 397px;
                box-sizing: border-box;
            }

            .el-input__inner {
                border: none !important;
                height: 52px !important;
                line-height: 52px;
                border-radius: 8px;
                padding-right: 30px;
            }

            .el-input__suffix {
                right: 10px;
            }

            .el-button+.el-button {
                margin-left: 16px;
            }

            .el-button,
            button {
                width: 108px;
                height: 52px;
                background: #ffffff !important;
                border: 1px solid #e1e4eb !important;
                border-radius: 8px;
                color: #5e6166 !important;
                font-size: 16px;
                text-align: center;
                padding: 0;
            }

            .active-batch {
                background: #fff6f3 !important;
                border: 1px solid $common-color !important;
                color: $common-color !important;
            }

            .el-input-group__append {
                padding: 0 !important;
                font-size: 16px;
                font-weight: 400;
                color: #5e6166;
                background: #fff;
                border: none !important;
                border-radius: 8px;
                position: relative;
                right: 16px;
            }

            .imitate-btn-diff {
                width: 72px !important;
            }

            .imitate-input-diff {
                width: 221px !important;
                margin-left: 16px;
            }

            .imitate-btn-submit {
                width: 240px !important;
                height: 50px !important;
                background: linear-gradient(90deg, #ffa94a, #ff913c) !important;
                border-radius: 8px;
                border: none !important;
                text-align: center;
                font-size: 18px;
                color: #ffffff !important;
                position: relative;
                left: 50%;
                transform: translateX(-50%);
                margin-top: 10px;
            }
        }

        .imitate-record-box {
            .imitate-record-title {
                font-size: 18px;
                color: #332e2c;
                font-weight: 600;
                line-height: 25px;
                margin: 24px 0 16px 0;
            }

            .imitate-echart-box {
                height: 210px;
                background: #f7f9fc;
                border-radius: 10px;
                padding: 16px;
                box-sizing: border-box;
                margin-bottom: 16px;

                h4 {
                    font-size: 14px;
                    font-weight: 600;
                    color: #332e2c;
                    line-height: 20px;
                    margin: 0;
                }
            }

            .imitate-canvas {
                width: 100%;
                height: 210px;
            }

            .imitate-record-item {
                padding: 16px 0;
                margin-bottom: 10px;
                border-bottom: 1px solid #e1e4eb;

                .imitate-zyb-infor {
                    font-size: 20px;
                    color: #2c2e33;
                    font-weight: 600;
                }

                span {
                    font-size: 14px;
                    font-weight: 400;
                    color: #5e6166 !important;
                    display: inline-block;
                }

                .imitate-lk-infor {
                    margin-left: 27px;
                }

                .imitate-zyb-span {
                    width: 1px;
                    height: 14px;
                    background: #c4c7cc;
                    position: relative;
                    top: 2px;
                    margin: 0 5px;
                }

                .imitate-zyb-date {
                    color: #909399;
                    font-size: 16px;
                    margin-top: 14px;

                    span {
                        color: $common_color !important;
                        margin-right: 24px;
                    }
                }

                .el-col-8 {
                    text-align: right;

                    button {
                        width: 44px;
                        height: 30px;
                        border: 1px solid $common-color;
                        border-radius: 4px;
                        font-size: 14px;
                        font-weight: 400;
                        color: $common-color !important;
                        text-align: center;
                        padding: 0;
                        line-height: 30px;
                        margin-top: 20px;
                        background: none;
                    }

                    button:hover {
                        background: none;
                    }
                }
            }
        }
    }
}
.no-data-box {
    text-align: center;
    img {
        margin-top: 16px;
    }
    p {
        font-size: 16px;
        color: #66605e;
        line-height: 22px;
        margin-top: 24px;
    }
}
</style>